// @flow

import 'styles/Globals';
import 'styles/Fonts';
import 'styles/Icons';
import ReactDOM from 'react-dom';
import HomieReactConfig from './homie-react-config';
import 'bootstrap/dist/css/bootstrap.min.css';

const renderRoot = container => {
  const root = document.getElementById('homie');
  if (!root) throw new Error("Root <div id='homie'></div> not defined.");
  HomieReactConfig.init();
  ReactDOM.render(container, root);
};

export default renderRoot;
